export default __webpack_public_path__ + "static/media/kloda_bartna.63158c2d.svg";